import { IconAlertTriangle } from "@tabler/icons-react";
import { BUILDER_LABELS } from "../../data/builderLabels";
import styles from "./QuestionCard.module.scss";

export function EmptyQuestionWarning() {
  return (
    <p className={styles.emptyQuestionWarning} role="status">
      <IconAlertTriangle size={14} aria-hidden className={styles.emptyQuestionWarningIcon} />
      <span className={styles.emptyQuestionWarningText}>{BUILDER_LABELS.emptyQuestionWarning}</span>
    </p>
  );
}
